import '@ui5/webcomponents/dist/Button'; // Import UI5 Button component

const ButtonNegative = (props) => {
  // Destructure props to ensure only relevant props are passed to the UI5 Button component
  const { children, ...rest } = props;

  return (
    <ui5-button design="Negative" {...rest}>
      {children}
    </ui5-button>
  );
};

export default ButtonNegative;

